exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__EmptyPanel__emptyTitle__1umsP {\n  background-color: #f6f6f6;\n  border-radius: 100px;\n  height: 22px;\n  margin: 0;\n  width: 126px;\n}\n\n.dmb-web__EmptyPanel__smallerHeight__1cpVC {\n  height: 13px;\n}\n\n.dmb-web__EmptyPanel__smallerWidth__3n1oD {\n  margin: 9px 0 0;\n  width: 88px;\n}\n\n.dmb-web__EmptyPanel__card__2p3hw {\n  background-color: white;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 0 rgb(0 0 0 / 21%);\n          box-shadow: 0 1px 4px 0 rgb(0 0 0 / 21%);\n  height: 59px;\n  margin: 10px;\n  padding: 16px;\n  width: calc(100% - 20px);\n}\n", ""]);

// exports
exports.locals = {
	"emptyTitle": "dmb-web__EmptyPanel__emptyTitle__1umsP",
	"smallerHeight": "dmb-web__EmptyPanel__smallerHeight__1cpVC",
	"smallerWidth": "dmb-web__EmptyPanel__smallerWidth__3n1oD",
	"card": "dmb-web__EmptyPanel__card__2p3hw"
};